import Modal from 'react-bootstrap/Modal'
import IAdNews from '../../interfaces/AdNews';

interface ModalProps {
    title: string;
    isOpen: boolean;
    setOpenModal: (val: boolean) => void;
    currentNews: IAdNews;
}

export const NewsModal: React.FC<ModalProps> = (props) => {
    return <Modal show={props.isOpen} onHide={() => props.setOpenModal(false)}>
        <Modal.Header>
            <Modal.Title><h5 className="mx-auto">{props.title}</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body className='mx-auto' >
            <small className="text-muted">{props.currentNews.SendDate}</small>
            <div
                id="modalBody"
                dangerouslySetInnerHTML={{
                    __html: (props.currentNews.Context || '').replace(/<a\/>/g, '</a>')
                }}
            />
            <style>{`
                        #modalBody {
                            color: #212529;
                        }
                        #modalBody a {
                            color: #1081f2ff;
                            text-decoration: none;
                        }
                        #modalBody a:hover {
                            text-decoration: underline;
                        }
                    `}</style>
        </Modal.Body>
        <Modal.Footer>
            <button type="button" className="btn btn-primary m-0" onClick={() => props.setOpenModal(false)}>關閉</button>
        </Modal.Footer>
    </Modal>

};